<template>
  <v-main>
    <v-container fluid style="padding: 0">
      <v-card
        class="elevation-0 hide-overflow d-flex flex-column align-stretch"
        height="100vh"
      />
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'Index',
};
</script>
